import { useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth.store'
import { useOnboarding } from '@/features/onboarding/hooks/useOnboarding'
import { OnboardingProgress } from '@/features/onboarding/components/OnboardingProgress'
import { OnboardingStep1 } from '@/features/onboarding/components/OnboardingStep1'
import { OnboardingStep2 } from '@/features/onboarding/components/OnboardingStep2'
import { OnboardingInterestsStep } from '@/features/onboarding/components/OnboardingInterestsStep'
import { OnboardingStep3 } from '@/features/onboarding/components/OnboardingStep3'
import { Spinner } from '@/components/ui/Spinner'
import { useTranslation } from 'react-i18next'

export function OnboardingPage() {
  const { t } = useTranslation()
  const user = useAuthStore((s) => s.user)
  const { currentStep, isLoadingStatus, nextStep, prevStep } = useOnboarding()
  const [personaName, setPersonaName] = useState('')

  if (user?.onboarding_completed_at) {
    return <Navigate to="/chat" replace />
  }

  if (isLoadingStatus) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner className="h-8 w-8 text-mindeia-primary" />
      </div>
    )
  }

  const handleStep2Next = (name?: string) => {
    if (name) setPersonaName(name)
    nextStep()
  }

  return (
    <div className="flex min-h-screen flex-col bg-surface-50">
      <header className="border-b border-surface-200 bg-white px-6 py-4">
        <div className="mx-auto flex max-w-3xl items-center justify-between">
          <span className="text-lg font-bold text-mindeia-primary">{t('app.name')}</span>
          <OnboardingProgress currentStep={currentStep} />
        </div>
      </header>

      <main className="flex flex-1 items-start justify-center px-4 py-10">
        <div className="w-full max-w-2xl rounded-2xl border border-surface-200 bg-white p-8 shadow-sm">
          {currentStep === 1 && <OnboardingStep1 onNext={nextStep} />}
          {currentStep === 2 && (
            <OnboardingStep2
              onNext={() => handleStep2Next()}
              onBack={prevStep}
            />
          )}
          {currentStep === 3 && <OnboardingInterestsStep onNext={nextStep} onBack={prevStep} />}
          {currentStep === 4 && <OnboardingStep3 personaName={personaName} />}
        </div>
      </main>
    </div>
  )
}
